import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const AboutPreview: React.FC = () => {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Content */}
          <div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-6">
              Who we are
            </h2>
            <div className="space-y-4 text-slate-600">
              <p>
                Enhance Companies started in 2022. We're a group of people who've been in insurance, 
                tech, and e-commerce, and we saw how broken the agent experience was at most places.
              </p>
              <p>
                Bad leads. Confusing comp structures. No support. Outdated tools. 
                We figured we could do better.
              </p>
              <p>
                So we built something different. Top carrier access. In-house leads. 
                Real technology. Actual humans who respond when you need help.
              </p>
              <p>
                We're not the biggest. We're not trying to be. We're trying to be the place 
                where agents who want to grow can actually do it.
              </p>
            </div>
            <div className="mt-8">
              <Link 
                to="/about"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="inline-flex items-center gap-2 text-navy-700 font-semibold hover:text-navy-800 transition-colors"
              >
                Learn more about us
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>

          {/* Right - Quick Facts */}
          <div className="bg-slate-50 border border-slate-200 rounded-xl p-8">
            <h3 className="text-lg font-semibold text-slate-900 mb-6">Quick facts</h3>
            <div className="space-y-6">
              <div className="flex justify-between items-center border-b border-slate-200 pb-4">
                <span className="text-slate-600">Founded</span>
                <span className="font-semibold text-slate-900">2022</span>
              </div>
              <div className="flex justify-between items-center border-b border-slate-200 pb-4">
                <span className="text-slate-600">Agents</span>
                <span className="font-semibold text-slate-900">1,000+</span>
              </div>
              <div className="flex justify-between items-center border-b border-slate-200 pb-4">
                <span className="text-slate-600">Carriers</span>
                <span className="font-semibold text-slate-900">28+</span>
              </div>
              <div className="flex justify-between items-center border-b border-slate-200 pb-4">
                <span className="text-slate-600">Annual premium</span>
                <span className="font-semibold text-slate-900">$40M+</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-slate-600">Support</span>
                <span className="font-semibold text-slate-900">24/7 Discord</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;
